"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerList = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var routerList = exports.routerList = [
// 省份管理
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "icon-jiaoyujuguanli",
    noCache: false,
    title: "省份管理"
  },
  name: null,
  path: "/province",
  redirect: "noRedirect",
  children: [{
    alwaysShow: null,
    children: [],
    component: "backstage/province/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "省份列表"
    },
    name: "provinceList",
    path: "provinceList",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/province/add",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增省份"
    },
    name: "provinceList-add",
    path: "provinceList-add",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/province/edit",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑省份"
    },
    name: "provinceList-edit",
    path: "provinceList-edit",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/province/setSys",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增省份管理员"
    },
    name: "provinceList-setSys",
    path: "provinceList-setSys",
    redirect: null
  }, {
    alwaysShow: false,
    children: [],
    component: "backstage/province/adminList",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "省份管理员列表"
    },
    name: "provinceAdminList",
    path: "provinceAdminList",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/province/editSys",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑省份管理员"
    },
    name: "provinceList-editSys",
    path: "provinceList-editSys",
    redirect: null
  }]
},
// 行政监管
{
  alwaysShow: false,
  component: "Layout",
  hidden: true,
  meta: {
    icon: "nested",
    noCache: false,
    title: "行政监管部门"
  },
  name: null,
  path: "/publicAdmin",
  redirect: null,
  children: [{
    alwaysShow: null,
    children: [],
    component: "backstage/publicAdmin/index",
    hidden: false,
    name: "publicAdminList",
    path: "publicAdmin-list",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "监管人员列表"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/publicAdmin/publicAdminAdd",
    hidden: false,
    name: "publicAdminAdd",
    path: "publicAdmin-add",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增监管人员"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/publicAdmin/publicAdminEdit",
    hidden: false,
    name: "publicAdminEdit",
    path: "publicAdmin-edit",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑监管人员"
    }
  }]
},
// 评审委员会
{
  alwaysShow: true,
  component: "Layout",
  hidden: true,
  meta: {
    icon: "nested",
    noCache: false,
    title: "评审委员会"
  },
  name: null,
  path: "/jury",
  redirect: "noRedirect",
  children: [{
    alwaysShow: null,
    children: [],
    component: "backstage/jury/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "评审委员会列表"
    },
    name: "juryList",
    path: "jury-list",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/jury/juryAdd",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增评审委员"
    },
    name: "juryAdd",
    path: "jury-add",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/jury/juryEdit",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑评审委员"
    },
    name: "juryEdit",
    path: "jury-edit",
    redirect: null
  }]
},
// 教育局管理
{
  alwaysShow: true,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "教育局管理"
  },
  name: null,
  path: "/schoolTest",
  redirect: "noRedirect",
  children: [{
    alwaysShow: null,
    children: [],
    component: "backstage/school/educationList",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "教育局列表"
    },
    name: "educationList",
    path: "educationList",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/school/educationAdd",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增教育局"
    },
    name: "educationList-add",
    path: "educationList-add",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/school/educationEdit",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑教育局"
    },
    name: "educationList-edit",
    path: "educationList-edit",
    redirect: null
  }, {
    alwaysShow: false,
    children: [],
    component: "backstage/school/educationAdminList",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "查看教育局管理员"
    },
    name: "educationAdminList",
    path: "educationAdminList",
    redirect: null
  }, {
    alwaysShow: false,
    children: [],
    component: "backstage/school/educationAdminAdd",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增教育局管理员"
    },
    name: "educationAdminAdd",
    path: "educationAdminAdd",
    redirect: null
  }, {
    alwaysShow: false,
    children: [],
    component: "backstage/school/educationAdminEdit",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑教育局管理员"
    },
    name: "educationAdminEdit",
    path: "educationAdminEdit",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/school/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "学校列表"
    },
    name: "school",
    path: "school",
    redirect: null
  }, {
    alwaysShow: false,
    component: "backstage/school/schoolAdd",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增学校"
    },
    name: "school-add",
    path: "school-add",
    redirect: null
  }, {
    alwaysShow: false,
    component: "backstage/school/schoolEdit",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑学校"
    },
    name: "school-edit",
    path: "school-edit",
    redirect: null
  }, {
    alwaysShow: false,
    component: "backstage/school/schoolView",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "查看学校管理员"
    },
    name: "school-view",
    path: "school-view",
    redirect: null
  }, {
    alwaysShow: false,
    component: "backstage/school/schoolViewAdd",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增(编辑)学校管理员"
    },
    name: "school-view-add",
    path: "school-view-add",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/school/schoolViewEdit",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑管理员信息"
    },
    name: "school-view-edit",
    path: "school-view-edit",
    redirect: null
  }]
},
// 学校管理
{
  alwaysShow: true,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "学校管理"
  },
  name: null,
  path: "/education",
  redirect: "noRedirect",
  children: [{
    alwaysShow: null,
    children: [],
    component: "backstage/education/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "教师列表"
    },
    name: "teacherList",
    path: "teacherList",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/education/teacherAdd",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增教师"
    },
    name: "teacherList-add",
    path: "teacherList-add",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/education/teacherEdit",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑教师"
    },
    name: "teacherList-edit",
    path: "teacherList-edit",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/education/project",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "项目列表"
    },
    name: "projectList",
    path: "projectList",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/education/registrationList",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "报名表列表"
    },
    name: "registrationList",
    path: "registrationList",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/education/worksCatalogue",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "作品清单"
    },
    name: "worksCatalogue",
    path: "worksCatalogue",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/education/viewProjectStage",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "项目阶段列表"
    },
    name: "viewProjectStage",
    path: "viewProjectStage",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/education/playerList",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "参赛选手分配"
    },
    name: "allotPlayerList",
    path: "allotPlayerList",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/education/viewWorks",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "作品列表"
    },
    name: "viewProjectWorks",
    path: "viewProjectWorks",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/education/workDetails",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "作品详情"
    },
    name: "workDetails",
    path: "workDetails",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/education/uploadWorks",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增作品"
    },
    name: "schoolUploadWorks",
    path: "schoolUploadWorks",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/education/apply",
    hidden: true,
    meta: {
      icon: "nested",
      noCache: false,
      title: "报名表列表"
    },
    name: "applyList",
    path: "applyList",
    redirect: null
  }]
}, // 精品在线课程申报
(0, _defineProperty2.default)({
  alwaysShow: true,
  component: "Layout",
  hidden: false,
  name: null,
  path: "/courseDeclare",
  redirect: "noRedirect",
  meta: {
    icon: "nested",
    noCache: false,
    title: "精品在线开放课程"
  },
  children: [{
    alwaysShow: null,
    children: [],
    component: "backstage/courseDeclare/projectListJs",
    hidden: false,
    name: "projectListJs",
    path: "projectListJs",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "项目列表"
    }
  }]
}, "children", [{
  alwaysShow: null,
  children: [],
  component: "backstage/courseDeclare/courseProEs",
  hidden: false,
  name: "courseProEs",
  path: "courseProEs",
  redirect: null,
  meta: {
    icon: "dashboard",
    noCache: false,
    title: "立项建设申报"
  }
}, {
  alwaysShow: null,
  children: [],
  component: "backstage/courseDeclare/acceptance",
  hidden: false,
  name: "acceptance",
  path: "acceptance",
  redirect: null,
  meta: {
    icon: "dashboard",
    noCache: false,
    title: "验收认定申报"
  }
}, {
  alwaysShow: null,
  children: [],
  component: "backstage/courseDeclare/declareList",
  hidden: false,
  name: "declareList",
  path: "declareList",
  redirect: null,
  meta: {
    icon: "dashboard",
    noCache: false,
    title: "申报列表"
  }
}, {
  alwaysShow: null,
  children: [],
  component: "backstage/courseDeclare/new_file",
  hidden: false,
  name: "new_file",
  path: "new_file",
  redirect: null,
  meta: {
    icon: "dashboard",
    noCache: false,
    title: "测试"
  }
}]),
// 项目管理
{
  alwaysShow: true,
  component: "Layout",
  hidden: false,
  name: null,
  path: "/object",
  redirect: "noRedirect",
  meta: {
    icon: "nested",
    noCache: false,
    title: "项目管理"
  },
  children: [
  // 项目标签管理
  {
    alwaysShow: null,
    children: [],
    component: "backstage/object/objectTag/index",
    hidden: false,
    name: "objectTag",
    path: "objectTag",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "项目标签管理"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/objectTag/objectTagAdd",
    hidden: true,
    name: "objectTag-add",
    path: "objectTag-add",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "新增项目标签类型"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/objectTag/objectTagEdit",
    hidden: true,
    name: "objectTag-edit",
    path: "objectTag-edit",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "编辑项目标签类型"
    }
  },
  // 项目类型管理
  {
    alwaysShow: null,
    children: [],
    component: "backstage/object/objectType/index",
    hidden: false,
    name: "objectType",
    path: "objectType",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "项目类型管理"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/objectType/objectTypeAdd",
    hidden: true,
    name: "objectType-add",
    path: "objectType-add",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "新增项目类型"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/objectType/objectTypeEdit",
    hidden: true,
    name: "objectType-edit",
    path: "objectType-edit",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "编辑项目类型"
    }
  },
  //项目管理
  {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/index",
    hidden: false,
    name: "object",
    path: "object",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "项目管理"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectAdmin",
    hidden: false,
    name: "objectAdmin",
    path: "objectAdmin",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "项目管理员列表"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectAdd",
    hidden: true,
    name: "objectAdd",
    path: "object-add",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "新增项目"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectGZAdd",
    hidden: true,
    name: "objectGZAdd",
    path: "objectGZ-add",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "新增项目"
    }
  },
  // {
  //   alwaysShow: null,
  //   children: [],
  //   component: "backstage/object/object/objectGZAdd",
  //   hidden: true,
  //   name: "objectGZAdd",
  //   path: "objectGZ-add",
  //   redirect: null,
  //   meta: {
  //     icon: "dashboard",
  //     noCache: false,
  //     title: "编辑项目"
  //   },
  // },
  {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/promiseList",
    hidden: true,
    name: "promiseList",
    path: "promiseList",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "承诺书列表"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectEdit",
    hidden: true,
    name: "objectEdit",
    path: "object-edit",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "编辑项目"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectGroupSet",
    hidden: true,
    name: "objectGroupSet",
    path: "objectGroupSet",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "项目组别设置"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectGroupSetAdd",
    hidden: true,
    name: "objectGroupSet-add",
    path: "objectGroupSet-add",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "新增项目组别"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectGroupSetEdit",
    hidden: true,
    name: "objectGroupSetEdit",
    path: "objectGroupSetEdit",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "编辑项目组别"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectUnitSet",
    hidden: true,
    name: "objectUnitSet",
    path: "objectUnitSet",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "项目单位设置"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectUnitSetAdd",
    hidden: true,
    name: "objectUnitSet-add",
    path: "objectUnitSetAdd",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "新增项目单位"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectStageSet",
    hidden: true,
    name: "objectStageSet",
    path: "objectStageSet",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "项目阶段设置"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectStageSetAdd",
    hidden: true,
    name: "objectStageSet-add",
    path: "objectStageSetAdd",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "新增项目阶段"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectStageSetEdit",
    hidden: true,
    name: "objectStageSet-edit",
    path: "objectStageSetEdit",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "编辑项目阶段"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/technocracy",
    hidden: true,
    name: "objectTechnocracy",
    path: "objectTechnocracy",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "专家管理"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/expertGrade",
    hidden: true,
    name: "expertGrade",
    path: "expertGrade",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "专家分配与评分规则"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/objectStageSetAndGroupSet",
    hidden: true,
    name: "objectStageSetAndGroupSet",
    path: "objectStageSetAndGroupSet",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "项目组别设置"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/entrySet",
    hidden: true,
    name: "entrySet",
    path: "entrySet",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "参赛作品设置"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/roleSet",
    hidden: true,
    name: "roleSet",
    path: "roleSet",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "权限设置"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/object/gradeItemSet",
    hidden: true,
    name: "gradeItemSet",
    path: "gradeItemSet",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "评分项设置"
    }
  },
  // 专业大类设置
  {
    alwaysShow: null,
    children: [],
    component: "backstage/object/majorObject/index",
    hidden: false,
    name: "majorObject",
    path: "majorObject",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "专业大类设置"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/majorObject/majorObjectAdd",
    hidden: true,
    name: "majorObjectAdd",
    path: "majorObject-add",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "新增专业大类"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/object/majorObject/majorObjectEdit",
    hidden: true,
    name: "majorObjectEdit",
    path: "majorObject-edit",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "编辑专业大类"
    }
  }]
},
// 专家管理
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "专家管理"
  },
  name: null,
  path: "/technocracyTest",
  redirect: "noRedirect",
  children: [{
    alwaysShow: null,
    children: [],
    component: "backstage/technocracy/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "专家列表"
    },
    name: "technocracy",
    path: "technocracy",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/technocracy/technocracyAdd",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增专家"
    },
    name: "technocracy-add",
    path: "technocracy-add",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/technocracy/technocracyEdit",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑专家"
    },
    name: "technocracy-edit",
    path: "technocracy-edit",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/technocracy/viewWorksList",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "查看作品列表"
    },
    name: "technocracy-viewWorksList",
    path: "technocracy-viewWorksList",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/technocracy/viewWorks",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "查看作品"
    },
    name: "technocracy-viewWorks",
    path: "technocracy-viewWorks",
    redirect: null
  }]
},
// 参赛作品
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "参赛作品管理"
  },
  name: null,
  path: "/entryDesignTest",
  redirect: "noRedirect",
  children: [{
    alwaysShow: null,
    children: [],
    component: "backstage/entryDesign/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "参赛作品管理"
    },
    name: "entryDesign",
    path: "entryDesign",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/entryDesign/list",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "参赛作品列表"
    },
    name: "list",
    path: "list",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/entryDesign/allocation",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "参赛作品分配"
    },
    name: "allocation",
    path: "allocation",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/entryDesign/comment",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "评分详情"
    },
    name: "comment",
    path: "comment",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/entryDesign/view",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "查看参赛作品"
    },
    name: "viewWorks",
    path: "view",
    redirect: null
  }]
},
// 赛事专栏
{
  alwaysShow: null,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "赛事专栏"
  },
  path: "/competition",
  redirect: null,
  children: [
  // 比赛作品列表
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/competition/index",
    hidden: false,
    meta: {
      title: "作品列表"
    },
    name: "worksList",
    path: "/worksList",
    redirect: null
  },
  // 比赛名称管理
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/competition/competitionName",
    hidden: false,
    meta: {
      title: "比赛名称管理"
    },
    name: "competitionName",
    path: "/competitionName",
    redirect: null
  },
  // 比赛名称管理
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/competition/type",
    hidden: false,
    meta: {
      title: "比赛类型"
    },
    name: "competitionType",
    path: "/competitionType",
    redirect: null
  },
  // 比赛名称管理
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/competition/news",
    hidden: false,
    meta: {
      title: "比赛公告"
    },
    name: "competitionNews",
    path: "/competitionNews",
    redirect: null
  }]
},
// 基础管理
{
  alwaysShow: null,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "基础管理"
  },
  path: "/basic",
  redirect: null,
  children: [
  // 行业分类
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/basic/addMajor",
    hidden: false,
    meta: {
      title: "专业大类"
    },
    name: "addMajor",
    path: "/addMajor",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/basic/industry",
    hidden: false,
    meta: {
      title: "行业分类"
    },
    name: "industry",
    path: "/industry",
    redirect: null
  }]
},
// 网站设置
{
  alwaysShow: true,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "网站管理"
  },
  name: null,
  path: "/webSet",
  redirect: "noRedirect",
  children: [
  // 院校版导航自定义
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/collegeNavSet/index",
    hidden: false,
    meta: {
      title: "院校版导航自定义"
    },
    name: "collegeNavSet",
    path: "/collegeNavSet",
    redirect: null
  },
  // 新闻管理
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/newsSet/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新闻管理"
    },
    name: "webSetNews",
    path: "webSet-news",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/newsSet/newsAdd",
    hidden: true,
    name: "webSetNewsAdd",
    path: "webSet-news-add",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增新闻"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/newsSet/newsEdit",
    hidden: true,
    name: "webSetNewsEdit",
    path: "webSet-news-edit",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑新闻"
    }
  },
  // 新闻分类管理
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/newsTypeSet/index",
    hidden: false,
    name: "webSetNewsType",
    path: "webSetNewsType",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新闻分类管理"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/newsTypeSet/newsTypeAdd",
    hidden: true,
    name: "webSetNewsType-add",
    path: "webSetNewsType-add",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增新闻分类"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/newsTypeSet/newsTypeEdit",
    hidden: true,
    name: "webSetNewsType-edit",
    path: "webSetNewsType-edit",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑新闻分类"
    }
  },
  // 轮播图管理
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/swiperSet/index",
    hidden: false,
    name: "webSetSwiper",
    path: "webSet-swiper",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "轮播图管理"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/swiperSet/swiperAdd",
    hidden: true,
    name: "webSetSwiperAdd",
    path: "webSet-swiper-add",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增轮播图"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/swiperSet/swiperEdit",
    hidden: true,
    name: "webSetSwiperEdit",
    path: "webSet-swiper-edit",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑轮播图"
    }
  },
  // 院校首页的轮播图管理//
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/swiperSchool/index",
    hidden: false,
    name: "swiperSchool",
    path: "swiperSchool",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "轮播图管理"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/swiperSchool/swiperAdd",
    hidden: true,
    name: "swiperSchoolAdd",
    path: "swiperSchoolAdd",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增轮播图"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/swiperSchool/swiperEdit",
    hidden: true,
    name: "swiperSchoolEdit",
    path: "swiperSchoolEdit",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑轮播图"
    }
  },
  // 友情链接管理
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/linksSet/index",
    hidden: false,
    name: "webSetLinks",
    path: "webSet-links",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "友情链接管理"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/linksSet/linksAdd",
    hidden: true,
    name: "webSetLinksAdd",
    path: "webSet-links-add",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增友情链接"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/linksSet/linksEdit",
    hidden: true,
    name: "webSetLinksEdit",
    path: "webSet-links-edit",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑友情链接"
    }
  },
  // 导航管理
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/navSet/index",
    hidden: false,
    name: "webSetNav",
    path: "webSetNav",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "导航管理"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/navSet/add",
    hidden: true,
    name: "webSetNav-add",
    path: "webSetNav-add",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增导航"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/navSet/edit",
    hidden: true,
    name: "webSetNav-edit",
    path: "webSetNav-edit",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑导航"
    }
  },
  // logo设置
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/logoSet/index",
    hidden: false,
    name: "logoSet",
    path: "logoSet",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "Logo管理"
    }
  }, {
    alwaysShow: null,
    component: "backstage/webSet/logoSet/provLogoAdd",
    hidden: true,
    name: "logoAdd",
    path: "logoAdd",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增省份Logo"
    }
  }, {
    alwaysShow: null,
    component: "backstage/webSet/logoSet/provLogoEdit",
    hidden: true,
    name: "logoEdit",
    path: "logoEdit",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑省份Logo"
    }
  },
  // 精品课程
  {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/courseSet/index",
    hidden: false,
    name: "courseSet",
    path: "courseSet",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "精品课程管理"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/courseSet/add",
    hidden: false,
    name: "courseSetAdd",
    path: "courseSetAdd",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "新增精品在线课程"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/webSet/courseSet/edit",
    hidden: false,
    name: "courseSetEdit",
    path: "courseSetEdit",
    redirect: null,
    meta: {
      icon: "nested",
      noCache: false,
      title: "编辑精品在线课程"
    }
  }]
},
// 角色管理
{
  alwaysShow: true,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "角色管理"
  },
  name: null,
  path: "/role",
  redirect: "noRedirect",
  children: [{
    alwaysShow: null,
    children: [],
    component: "backstage/role/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "角色列表"
    },
    name: "roleList",
    path: "roleList",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/role/provinceRoleList",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "省份列表"
    },
    name: "provinceRoleList",
    path: "provinceRoleList",
    redirect: null
  }]
},
// 菜单管理
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "菜单管理"
    // breadcrumb:false
  },
  name: null,
  path: "/menu",
  redirect: "noRedirect",
  children: [{
    alwaysShow: true,
    component: "backstage/menuSet/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "菜单列表"
    },
    name: "menuList",
    path: "menuList",
    redirect: null
  }]
},
// 报名表
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "报名表管理"
  },
  name: null,
  path: "/apply",
  redirect: "noRedirect",
  children: [{
    alwaysShow: null,
    children: [],
    component: "backstage/apply/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "报名表列表"
    },
    name: "List",
    path: "List",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/apply/view",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "查看报名表"
    },
    name: "view",
    path: "view",
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/apply/audit",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "审核报名表"
    },
    name: "audit",
    path: "audit",
    redirect: null
  }]
},
// 虚拟仿真课
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "dashboard",
    noCache: false,
    title: "虚拟仿真课",
    breadcrumb: false
  },
  name: null,
  path: "/virtualSimulationClass",
  redirect: null,
  children: [{
    alwaysShow: false,
    component: "backstage/virtualSimulationClass/index.vue",
    hidden: false,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "虚拟仿真课"
    },
    name: "virtualSimulationClass",
    path: "virtualSimulationClass",
    children: [],
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/virtualSimulationClass/virtualSimulationClassAdd.vue",
    hidden: true,
    name: "virtualSimulationClassAdd",
    path: "virtualSimulationClassAdd",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "新增虚拟仿真课"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/virtualSimulationClass/virtualSimulationClassEdit.vue",
    hidden: true,
    name: "virtualSimulationClassEdit",
    path: "virtualSimulationClassEdit",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "编辑虚拟仿真课"
    }
  }]
},
// 新形态教材
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "dashboard",
    noCache: false,
    title: "新形态教材",
    breadcrumb: false
  },
  name: null,
  path: "/newTeachingMaterial",
  redirect: null,
  children: [{
    alwaysShow: false,
    component: "backstage/newTeachingMaterial/index.vue",
    hidden: false,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "新形态教材"
    },
    name: "newTeachingMaterial",
    path: "newTeachingMaterial",
    children: [],
    redirect: null
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/newTeachingMaterial/newTeachingMaterialAdd.vue",
    hidden: true,
    name: "newTeachingMaterialAdd",
    path: "newTeachingMaterialAdd",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "新增新形态教材"
    }
  }, {
    alwaysShow: null,
    children: [],
    component: "backstage/newTeachingMaterial/newTeachingMaterialEdit.vue",
    hidden: true,
    name: "newTeachingMaterialEdit",
    path: "newTeachingMaterialEdit",
    redirect: null,
    meta: {
      icon: "dashboard",
      noCache: false,
      title: "编辑新形态教材"
    }
  }]
},
// 个人信息
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "个人中心",
    breadcrumb: false
  },
  name: null,
  path: "/userInfoSet",
  redirect: '/userHdChange',
  children: [{
    alwaysShow: false,
    component: "backstage/userInfo/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "基本信息"
    },
    name: "userHdChange",
    path: "/userHdChange",
    children: [],
    redirect: null
  }, {
    alwaysShow: false,
    component: "backstage/userInfo/pwdChange",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "账号设置"
    },
    name: "pwdChange",
    path: "pwdChange",
    children: [],
    redirect: null
  }]
},
// 专家打分
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "作品评审",
    breadcrumb: false
  },
  name: null,
  path: "/grade",
  redirect: null,
  children: [{
    alwaysShow: false,
    component: "backstage/grade/projectList",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "项目列表"
    },
    name: "gradeList-project",
    path: "gradeList-project"
  }, {
    alwaysShow: false,
    component: "backstage/grade/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "作品列表"
    },
    name: "gradeList",
    path: "grade-list",
    redirect: null
  }, {
    alwaysShow: false,
    component: "backstage/grade/viewWorks",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "作品详情"
    },
    name: "viewWorks",
    path: "viewWorks",
    redirect: null
  }]
},
// 作品打分
{
  alwaysShow: false,
  component: "ParentView",
  hidden: true,
  meta: {
    icon: "nested",
    noCache: false,
    title: "作品打分"
  },
  name: "gradeScore",
  path: "/gradeScore",
  redirect: null,
  children: [{
    alwaysShow: false,
    component: "backstage/grade/score",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "作品打分"
    },
    name: "gradeScoreX",
    path: "gradeScoreX",
    redirect: null
  }]
},
// 选手
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "项目管理",
    breadcrumb: false
  },
  name: null,
  path: "/player",
  redirect: "noRedirect",
  children: [{
    alwaysShow: false,
    component: "backstage/player/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "我的项目"
    },
    name: "myProject",
    path: "myProject",
    redirect: null
  }, {
    alwaysShow: false,
    component: "backstage/player/playerGZ",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "贵州"
    },
    name: "myProjectGZ",
    path: "myProjectGZ",
    redirect: null
  }, {
    alwaysShow: false,
    component: "backstage/player/playerList",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "项目列表"
    },
    name: "playerList",
    path: "playerList",
    redirect: null
  }, {
    alwaysShow: false,
    component: "backstage/player/uploadWorks",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "提交作品"
    },
    name: "uploadWorks",
    path: "uploadWorks",
    redirect: null
  }, {
    alwaysShow: false,
    component: "backstage/player/viewWorks",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "查看作品"
    },
    name: "viePlayerWorks",
    path: "viewWorks",
    redirect: null
  }]
},
// 系统设置
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "系统设置",
    breadcrumb: false
  },
  name: null,
  path: "/systemSet",
  redirect: "noRedirect",
  children: [{
    alwaysShow: false,
    component: "backstage/systemSet/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "系统设置"
    },
    name: "systemSetInfo",
    path: "systemSetInfo",
    redirect: null
  }]
},
// 注册管理
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "注册管理",
    breadcrumb: false
  },
  name: null,
  path: "/registerManagement",
  redirect: null,
  children: [{
    alwaysShow: true,
    component: "backstage/registerManagement/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "注册管理"
    },
    name: "registerList",
    path: "registerList",
    redirect: null
  }]
},
// 项目管理员
{
  alwaysShow: false,
  component: "Layout",
  hidden: false,
  meta: {
    icon: "nested",
    noCache: false,
    title: "项目管理员",
    breadcrumb: false
  },
  name: null,
  path: "/objectAdmin",
  redirect: null,
  children: [{
    alwaysShow: true,
    component: "backstage/objectAdminList/index",
    hidden: false,
    meta: {
      icon: "nested",
      noCache: false,
      title: "项目管理员列表"
    },
    name: "objectAdminList",
    path: "objectAdminList",
    redirect: null
  }]
}];